<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Freight',
      breadcrumb: {
        name: 'Freight',
        route: { name: 'freight' }
      },
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'freight-dashboard' },
          name: 'Dashboard'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'boxes'],
          route: { name: 'freight-consignments-v3' },
          name: 'Consignments'
        },
        {
          hidden: this.$user.cannot(READ, 'tracking'),
          icon: ['fal', 'map-marked'],
          route: { name: 'freight-tracking' },
          name: 'Tracking'
        },
        {
          icon: ['fal', 'clock'],
          route: { name: 'freight-deliverytimes' },
          name: 'Delivery Times'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_rates_ratesCustomerQuote'),
          icon: ['fal', 'money-check-alt'],
          route: { name: 'freight-quote-v3' },
          name: 'Quote'
        },
        {
          hidden: this.$user.cannot(READ, 'edi'),
          icon: ['fal', 'chart-network'],
          route: { name: 'freight-edi-v3' },
          name: 'EDI'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.consignment),
          icon: ['fal', 'boxes'],
          route: { name: 'freight-consignments' },
          name: 'Consignments (Old)'
        },
        {
          hidden: this.$user.cannot(READ, 'edi'),
          icon: ['fal', 'chart-network'],
          route: { name: 'freight-edi' },
          name: 'EDI (Old)'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_rates_ratesCustomerQuote'),
          icon: ['fal', 'money-check-alt'],
          route: { name: 'freight-quote' },
          name: 'Quote (Old)'
        }
      ]
    }
  }
}
</script>
